import { Box, BoxProps } from '@amzn/awsui-components-core';
import React from 'react';
import { getCurrentUserLocalTimeReadableFormat } from 'src/utilities/DateTimeUtilities';

interface LastRefreshedAtProps {
  lastRefreshedDateTime?: string;
  /** OPT-IN override for the inner Box's font size (e.g. "body-s" for 12px) — omit to keep the existing default (body-m, 14px) exactly as every current caller already sees it (e.g. Cost Metrics v2). Box's own default font-size wins over any font-size set by an ancestor wrapper, so a page wanting a smaller caption must opt in here rather than relying on inherited/cascaded CSS. */
  fontSize?: BoxProps.FontSize;
}
const LastRefreshedAt: React.FC<LastRefreshedAtProps> = ({ lastRefreshedDateTime, fontSize }) => {
  return (
    <>
      {!lastRefreshedDateTime && <></>}
      {lastRefreshedDateTime && (
        <div className={lastRefreshedDateTime === '' ? 'no-border' : 'thin-border'}>
          <Box color="text-body-secondary" fontSize={fontSize}>{`Last data refresh: ${getCurrentUserLocalTimeReadableFormat(
            lastRefreshedDateTime
          )}`}</Box>
        </div>
      )}
    </>
  );
};

export default LastRefreshedAt;
